import { atom } from 'recoil';
import {
  exerciseSelectorGet,
  nutritionSelectorGet,
  recommenderExercisesSelectorGet,
  userProfileSelectorGet,
  dna24ProfileSelectorGet,
  genotypeStatusSelectorGet,
  recommenderRecipesSelectorGet,
  recommenderMealplanSelectorGet,
} from 'dataLayer/recoil/apiData/defaultSelectors';

export const userProfileAtom = atom({
  key: 'apiData/atoms/userProfile',
  default: userProfileSelectorGet,
});

export const exerciseAtom = atom({
  key: 'apiData/atoms/exercise',
  default: exerciseSelectorGet,
});

export const nutritionAtom = atom({
  key: 'apiData/atoms/nutrition',
  default: nutritionSelectorGet,
});

export const dna24ProfileAtom = atom({
  key: 'apiData/atoms/dn24Profile',
  default: dna24ProfileSelectorGet,
});

export const genotypeStatusAtom = atom({
  key: 'apiData/atoms/genotypeStatus',
  default: genotypeStatusSelectorGet,
});

export const recommenderExercisesAtom = atom({
  key: 'apiData/atoms/recommenderExercises',
  default: recommenderExercisesSelectorGet,
});

export const recommenderRecipesAtom = atom({
  key: 'apiData/atoms/recommenderRecipes',
  default: recommenderRecipesSelectorGet,
});

export const recommenderMealplanAtom = atom({
  key: 'apiData/atoms/recommenderMealplan',
  default: recommenderMealplanSelectorGet,
});
